export default {
  region: 'Region',
  calling: 'Calling',
  logout: 'Logout',
  version: 'Version',
  settings: 'Settings',
  selectToDialSMS: 'Select to Dial/SMS',
  selectToDial: 'Select to Dial',
  selectToSMS: 'Select to SMS',
  clickToDial: 'Click to Dial',
  autoCreateLog: 'Auto-create Call Log',
  autoCreateSMSLog: 'Auto-create SMS Log',
  autoLogCalls: 'Auto log calls',
  autoLogNotes: 'Auto log notes',
  autoLogSMS: 'Auto log SMS',
  clickToSMS: 'Click to SMS',
  logSMSContent: 'Log SMS content',
  clickToDialSMS: 'Click to Dial/SMS',
  logExtensionCall: 'Log extension calls',
  audio: 'Audio',
  language: 'Language',
  feedback: 'Feedback',
  userGuide: "What's New",
  quickAccess: 'Quick Access Setting',
  report: 'Analytics Report',
  shareIdea: 'Share idea',
  openEntityFrom: 'Salesforce object behavior',
  ctiPanelSize: 'CTI panel size',
  openInNewTab: 'Open in new tab',
  openInCurrentTab: 'Open in current tab',
  reportIssue: 'Report issue',
  contactSupport: 'Contact support',
  selectToDialHint:
    'For your better experience, select phone number to dial with RingCentral in large quantity phone number page.',
} as const;
